import GuestMagentoClient from './Clients/GuestMagentoClient'
import RegisteredMagentoClient from './Clients/RegisteredMagentoClient'

const GUEST_CLIENT = 'guest'
const REGISTERED_CLIENT = 'registered'

export class MagentoClientFactory {
  static create (type, domain, quoteId, currentUrl, token) {
    switch (type) {
      case GUEST_CLIENT:
        return new GuestMagentoClient(domain, quoteId, currentUrl)
      case REGISTERED_CLIENT:
        return new RegisteredMagentoClient(domain, quoteId, currentUrl, token)
      default:
        return null
    }
  }
}
